import { render, staticRenderFns } from "./StreamOwnerBatches.vue?vue&type=template&id=b75871b6&"
import script from "./StreamOwnerBatches.vue?vue&type=script&lang=ts&"
export * from "./StreamOwnerBatches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports